import get from 'lodash/get';
import { getInstance as getBootstrap } from 'utils/bootstrap';
import { setNewNotification } from 'common/compounds/Notification/modules';
import { SUCCESS, INFO, ERROR } from 'common/compounds/Notification/constants/types';

const bootstrap = getBootstrap();

/**
 * @param {object} store - redux store object
 *
 * Helper function to read legacy flash messages from bootstrap data and display them
 * with the Notification compound. NOTE: In order to use this function, the Notification compound
 * must have been aded to the redux store already.
 */
export default function readFlashMessage(store) {
    const flashMessage = bootstrap.get('flashMessage');

    if (flashMessage && flashMessage.message) {
        const addedClass = get(flashMessage, 'params.class');
        const variation = addedClass === 'error_area' ? ERROR : addedClass === 'success_area' ? SUCCESS : INFO;
        store.dispatch(setNewNotification(flashMessage.message, variation, 5000));
    }
}
